import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { SAGE_CUSTOMER_CODE_HELPER } from 'src/core/utils/sage-customer-code';

@Component({
  selector: 'core-sage-customer-code-field',
  templateUrl: './sage-customer-code-field.component.html',
  styleUrls: ['./sage-customer-code-field.component.scss'],
  standalone: false,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class SageCustomerCodeFieldComponent {
  readonly helper = SAGE_CUSTOMER_CODE_HELPER;
}
